import React from 'react';
import { ArrowRightIcon, DownloadIcon, InfinityIcon, ShieldCheckIcon, BanIcon } from 'lucide-react';
import { heroImage } from '../data/content';
const garantias = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: BanIcon,
  label: 'Sin suscripciones'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-84" data-mp="12860lxyjoar2">
      <div className="mx-auto max-w-content px-5 py-12 sm:py-16 lg:py-24" data-id="element-85" data-mp="xanra6gm7tij">
        <div className="mx-auto max-w-3xl text-center" data-id="element-86" data-mp="x8jnrpmmowis">
          

          <h1 className="mt-4 font-display text-[32px] leading-[1.1] text-cream sm:mt-5 sm:text-5xl sm:leading-[1.08] lg:text-[62px]" style={{
          fontSize: "45px"
        }} data-id="element-87" data-mp="s9q8psrp0xgi">
            Guía una sesión de Hipnosis regresiva profunda y segura
            <span className="block text-gold" data-id="element-88" data-mp="3cz5x6h3fwa2z">entendiendo a cada paciente</span>
          </h1>

          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-muted sm:mt-6 sm:text-lg" style={{
          fontSize: '11px'
        }} data-id="element-89" data-mp="384s4img5wh20">
            Únete a más de 500 terapeutas y facilitadores que dejaron de dudar en sesión.
            Entra al consultorio con la estructura exacta para guiar, liberar y acompañar
            con total criterio y autoridad.
          </p>
        </div>

        <div className="mx-auto mt-8 w-full max-w-[260px] sm:mt-12 sm:max-w-md" data-id="element-90" data-mp="30i18d5yke5em">
          <div className="rounded-2xl border border-line bg-ink-raised p-3.5 shadow-2xl shadow-black/60 sm:p-5" data-id="element-91" data-mp="30fy7trzsctvn">
            <img src={heroImage} alt="Manual impreso Hipnosis Regresiva — Memorias del Alma™ sobre un escritorio de madera con cuarzos y velas" className="w-full rounded-xl" width={1024} height={1024} data-id="element-92" data-mp="35akifsy1mieo" />
          </div>
          <div className="mt-3.5 flex items-center justify-center gap-2.5 text-[10px] uppercase tracking-[0.16em] text-muted sm:mt-4 sm:gap-3 sm:text-[12px] sm:tracking-[0.18em]" data-id="element-93" data-mp="2hjf8fuesakca">
            <span className="h-px w-6 bg-line sm:w-8" aria-hidden="true" data-id="element-94" data-mp="2lmld4xm903gn" />
            3 tomos · 90+ páginas · 3 bonos
            <span className="h-px w-6 bg-line sm:w-8" aria-hidden="true" data-id="element-95" data-mp="nbl0ygmt488c" />
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center sm:mt-10" data-id="element-96" data-mp="ibp18tl572yl">
          <a href="#oferta" className="group inline-flex items-center gap-2.5 rounded-full bg-gold px-6 py-4 font-sans text-[14px] font-semibold leading-none text-[#1B0F00] transition-[transform,background-color] duration-150 ease-out hover:bg-[#E8C480] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.98] sm:gap-3 sm:px-7 sm:text-[15px]" style={{
          fontSize: "17px"
        }} data-id="element-97" data-mp="i9vqp37erylb">
            Quiero el Sistema Memorias del Alma™
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="x37bearbm3a1" />
          </a>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:mt-7 sm:gap-x-6" data-id="element-99" data-mp="3hqam6y4cdrp9">
            {garantias.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap text-[12px] text-muted sm:gap-2 sm:text-[13px]" data-id="element-100" data-mp="21a4ubxltom71">
                <Icon className="h-3.5 w-3.5 shrink-0 text-amethyst" aria-hidden="true" data-id="element-101" data-mp="267wicgjcjo5y" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}